import { Spreadsheet } from "react-spreadsheet"

// Cell type from read-excel-file (not exported from main package)
// Matches: type Cell = string | number | boolean | typeof Date
type Cell = string | number | boolean | typeof Date

export type SpreadsheetData = {
  value: Cell
  readOnly: boolean
}[][]

type SpreadsheetViewerProps = {
  data: SpreadsheetData
}

export function SpreadsheetViewer({ data }: SpreadsheetViewerProps) {
  return (
    <Spreadsheet
      className="!bg-background [&_span]:!text-muted-foreground [&th]:!text-muted-foreground max-h-[500px] !w-full !overflow-auto"
      data={data}
    />
  )
}
